export default __webpack_public_path__ + "static/media/36I-102694_-15653_0.78e04c8d.jpg";